import { render } from "./QuranMetaList.vue?vue&type=template&id=65d088ea"
import script from "./QuranMetaList.vue?vue&type=script&lang=js"
export * from "./QuranMetaList.vue?vue&type=script&lang=js"
script.render = render

export default script